import { catchError, Observable, throwError } from 'rxjs';

// Error carrying the original HTTP status through the wrapper so callers can distinguish
// likely-transient failures (network/5xx/404) from stable ones (401/403) without re-parsing.
export interface WrappedRequestError extends Error {
  status?: number;
}

export function withErrorHandling<T>(obs$: Observable<T>, context: string): Observable<T> {
  return obs$.pipe(
    catchError((err) => {
      console.error(`[${context}]`, err);
      const message = err?.message || 'Unexpected error';
      const wrapped: WrappedRequestError = new Error(`${context}: ${message}`);
      // HttpErrorResponse exposes a numeric `status` (0 for network failures); keep it.
      if (typeof err?.status === 'number') {
        wrapped.status = err.status;
      }
      return throwError(() => wrapped);
    })
  );
}
